// SY07 공통코드 저장 — 2.0 POST /api/v1/common-codes(새 행, LOGISPRD-9682) · PUT /api/v1/common-codes/{id}(기존 행, LOGISPRD-9621, 단건 전체 교체)
// 화면 스펙(핸드오프 ma-sy07)은 [저장]만 — 선택 행을 행별로 순서대로 반영한다. _id 없음 = [추가]로 생긴 새 행.
// (shipperCode, codeGrp, code) 중복 시 BE 400 (ERROR_ALREADY_EXIST).
// 실패하면 그 자리에서 멈추고, 앞서 반영된 건수를 오류의 done 에 싣는다(화면이 반영분을 정리하고 "N건 중 K건" 을 안내한다).
import { useMutation, type UseMutationResult } from '@tanstack/react-query'
import request from '@/utils/request'
import { CommonCodeRow } from './useGetCommonCodeList'
import { inOrder } from '@/utils/inOrder'

interface CommonCodeSaveBody {
  shipperCode: string
  code: string
  codeDesc: string
  codeGrp: string | null
}

export type CommonCodeSaveRow = Omit<CommonCodeRow, '_id'> & { _id?: number }

export const useSaveCommonCodes = (): UseMutationResult<number, Error, CommonCodeSaveRow[]> =>
  useMutation({
    mutationFn: (rows: CommonCodeSaveRow[]) =>
      inOrder(rows, (row) => {
        const body = { shipperCode: row.SPR_NM, code: row.CODE, codeDesc: row.CODE_DESC, codeGrp: row.CODE_GRP || null }
        return row._id == null
          ? request.post<ApiResponseV2<unknown>, CommonCodeSaveBody>('/api/v1/common-codes', body)
          : request.put<ApiResponseV2<unknown>, CommonCodeSaveBody>(`/api/v1/common-codes/${row._id}`, body)
      }),
  })
